module.exports = __webpack_public_path__ + "img/intel-logo.11eff7c3.svg";